import { COLLAPSE_INDICATOR, FOLDER_SEPARATOR } from "../constants/folderNaming.js";
export function shortenFolderLabel(label, threshold) {
  const splitLabel = label.split(FOLDER_SEPARATOR);
  if (splitLabel.length <= 2 || label.length < threshold) {
    return {
      label,
      removedCharsAmount: 0
    };
  }
  const newLabel = `${splitLabel[0]}${FOLDER_SEPARATOR}${COLLAPSE_INDICATOR}${FOLDER_SEPARATOR}${splitLabel[splitLabel.length - 1]}`;
  return {
    label: newLabel,
    removedCharsAmount: label.length - newLabel.length
  };
}